import { useQuery } from 'react-query';
import { request } from '../utility/axios-utils';

const GetUIDetails = (data) => {
  return request({
    url: '/settings/getUIData?url=' + data,
    method: 'get',
    headers: { 'Content-Type': 'application/json' },
  });
};

export const useHeaderData = (url) => useQuery('fetch-UI-details', () => GetUIDetails(url));
